import KOGImageZoom from "@/main/components/shared/kogImageZoom/zoomableImage";
import * as S from "../styles";
import { IPreviewComponentProps } from "./types";
import { isEmpty } from "lodash";
import { IMAGE_DEFAULT } from "@/main/services/constants";

export const ImagePreview: React.FC<IPreviewComponentProps> = ({ fileUrl, showPreview }) => {
	const src = isEmpty(fileUrl) ? IMAGE_DEFAULT : fileUrl;

	return (
		<S.ContainerImagePreview>
			{showPreview ? (
				<KOGImageZoom
					src={src}
					alt=""
					onErrorImg={(e) => {
						e.currentTarget.src = IMAGE_DEFAULT;
					}}
				/>
			) : (
				<img
					src={src}
					alt=""
					onError={(e) => {
						e.currentTarget.src = IMAGE_DEFAULT;
					}}
				/>
			)}
		</S.ContainerImagePreview>
	);
};
